import { ICategory, ICategoryPath } from 'categories/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const ROOT_CATEGORY_ID = 7;

export const getCategories = async (
  requestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICategory>> => {
  const { data } = await partfinitiClient.get(
    `/categories/category-list/categories?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  const categories = data.categories.map((category) => {
    return {
      ...category,
      path: getCategoryPath(category),
    };
  });

  return mapRecordsFromServer<ICategory>(categories);
};

// The categories a Part Finder family can be filed under: every one but the root, which the back
// end refuses (error_part_finder_family_category_invalid) and an unfiltered search would offer.
export const getSelectableCategories = async (
  requestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICategory>> => {
  const response = await getCategories(requestPayload, signal);

  return {
    ...response,
    records: response.records?.filter((category) => category.id !== ROOT_CATEGORY_ID) ?? [],
  };
};

const getCategoryPath = ({
  path,
  path_ids: pathIds,
}: {
  path: string;
  path_ids: string;
}): ICategoryPath[] => {
  const pathItems = path.split(',');
  const pathIdsItems = pathIds?.split(',') || [];

  return pathIdsItems.map((id, index) => {
    return {
      id: Number(id),
      name: pathItems[index - 1],
      level: index,
    };
  });
};
